"use client";

import { c as _c } from "react/compiler-runtime";
import DropsListItemDeleteDropModal from "@/components/drops/view/item/options/delete/DropsListItemDeleteDropModal";
import CommonAnimationOpacity from "@/components/utils/animation/CommonAnimationOpacity";
import CommonAnimationWrapper from "@/components/utils/animation/CommonAnimationWrapper";
import type { ApiDrop } from "@/generated/models/ApiDrop";
import { TrashIcon } from "@heroicons/react/24/outline";
import React, { useState } from "react";
import { Tooltip } from "react-tooltip";
interface WaveDropActionsOptionsProps {
  readonly drop: ApiDrop;
  readonly isDropdownItem?: boolean | undefined;
  readonly onDelete?: (() => void) | undefined;
}
const WaveDropActionsOptions: React.FC<WaveDropActionsOptionsProps> = t0 => {
  const $ = _c(23);
  const {
    drop,
    isDropdownItem: t1,
    onDelete
  } = t0;
  const isDropdownItem = t1 === undefined ? false : t1;
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  if (isDropdownItem) {
    let t2;
    if ($[0] !== onDelete) {
      t2 = e => {
        e.stopPropagation();
        onDelete?.();
      };
      $[0] = onDelete;
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    let t3;
    let t4;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <TrashIcon className="tw-h-4 tw-w-4 tw-flex-shrink-0" />;
      t4 = <span className="tw-text-sm tw-font-medium">Delete</span>;
      $[2] = t3;
      $[3] = t4;
    } else {
      t3 = $[2];
      t4 = $[3];
    }
    let t5;
    if ($[4] !== t2) {
      t5 = <button type="button" onClick={t2} className="tw-flex tw-w-full tw-cursor-pointer tw-items-center tw-gap-x-3 tw-rounded-lg tw-border-0 tw-bg-transparent tw-px-3 tw-py-2 tw-text-iron-300 tw-transition-colors tw-duration-200 desktop-hover:hover:tw-bg-iron-800 desktop-hover:hover:tw-text-rose-400">{t3}{t4}</button>;
      $[4] = t2;
      $[5] = t5;
    } else {
      t5 = $[5];
    }
    return t5;
  }
  let t2;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = e_0 => {
      e_0.stopPropagation();
      setIsDeleteModalOpen(true);
    };
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const handleOpenModal = t2;
  const t3 = `delete-${drop.id}`;
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <TrashIcon className="tw-h-4 tw-w-4 tw-flex-shrink-0" />;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t3) {
    t5 = <button type="button" onClick={handleOpenModal} className="tw-cursor-pointer tw-border-0 tw-bg-transparent tw-px-2 tw-text-iron-400 tw-transition-colors desktop-hover:hover:tw-text-rose-400" aria-label="Delete drop" data-tooltip-id={t3}>{t4}</button>;
    $[8] = t3;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const t6 = `delete-${drop.id}`;
  let t7;
  let t8;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      borderRadius: "6px",
      boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
      backgroundColor: "#1F2937",
      color: "white",
      padding: "4px 8px",
      zIndex: 10000,
      pointerEvents: "none"
    };
    t8 = <span className="tw-text-xs">Delete</span>;
    $[10] = t7;
    $[11] = t8;
  } else {
    t7 = $[10];
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t6) {
    t9 = <Tooltip id={t6} place="top-end" offset={8} opacity={1} positionStrategy="fixed" style={t7}>{t8}</Tooltip>;
    $[12] = t6;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== drop || $[15] !== isDeleteModalOpen) {
    t10 = isDeleteModalOpen && <CommonAnimationOpacity key="modal" elementClasses="tw-absolute tw-z-50" elementRole="dialog" onClicked={_temp}><DropsListItemDeleteDropModal drop={drop} closeModal={() => setIsDeleteModalOpen(false)} /></CommonAnimationOpacity>;
    $[14] = drop;
    $[15] = isDeleteModalOpen;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== t10) {
    t11 = <CommonAnimationWrapper mode="sync" initial={true}>{t10}</CommonAnimationWrapper>;
    $[17] = t10;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== t11 || $[20] !== t5 || $[21] !== t9) {
    t12 = <>{t5}{t9}{t11}</>;
    $[19] = t11;
    $[20] = t5;
    $[21] = t9;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  return t12;
};
export default WaveDropActionsOptions;
function _temp(e_1) {
  return e_1.stopPropagation();
}